// extracted by mini-css-extract-plugin
var _1 = "CommentThreadCompact-module__icon--Nvvx3";
export { _1 as "icon" }
